import { capitalCase } from 'change-case'
import { ActionProgressStatus } from '../generated/graphql'

export const formatActionProgressStatus = (actionProgress?: ActionProgressStatus | null) => {
  if (!actionProgress) return ''
  return capitalCase(actionProgress)
}
